import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';

import { RootState } from '@root/app.state';
import { back } from '@platform/router.actions';

@Component({
  selector: 'app-navigation-error',
  templateUrl: './navigation-error.component.html',
  styleUrls: ['./navigation-error.component.scss'],
  standalone: false,
})
export class NavigationErrorComponent implements OnInit {
  constructor(private store$: Store<RootState>) {}

  ngOnInit(): void {}

  public back(): void {
    this.store$.dispatch(back());
  }
}
